import { Injectable } from "@angular/core";
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { ComponentCanDeactivate } from "./can-deactivate-component";
import { CclNotifyService, CclMessageService, CclNavbarFooterService } from "certain-common-library";
import { SharedService } from "../../../modules/shared/services/shared.service";
import { Subject } from "rxjs";

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
    constructor(
        private notifyService: CclNotifyService,
        private shareService: SharedService,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService
    ) {}

    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
        if (component != null && !component.canDeactivate()) {
            const pnotify = this.notifyService.getPNotify();
            const subject = new Subject<boolean>();
            let temp = pnotify.alert({
                title: "Unsaved changes",
                text: "You have unsaved changes! If you leave, your changes will be lost.",
                addClass: "c-pnotify-confirm",
                hide: false,
                textTrusted: true,
                modules: {
                    Confirm: {
                        confirm: true,
                        align: "flex-end",
                        buttons: [
                            {
                                text: "Save",
                                textTrusted: false,
                                addClass: "",
                                primary: true,
                                promptTrigger: true,
                                click: (notice, value) => {
                                    this.messageService.sendMessage(
                                        this.navbarFooterService.navbar.rightNavbarItems[1].message
                                    );
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                    subject.next(true);
                                    subject.complete();
                                    return true;
                                }
                            },
                            {
                                text: "Discard",
                                textTrusted: false,
                                addClass: "unsaved-btn--secondary",
                                primary: true,
                                promptTrigger: true,
                                click: (notice, value) => {
                                    notice.close();
                                    notice.fire("pnotify.cancel", { notice, value });
                                    this.shareService.unsavedData = false;
                                    subject.next(true);
                                    subject.complete();
                                    return true;
                                }
                            },
                            {
                                text: "Cancel",
                                textTrusted: false,
                                addClass: "unsaved-btn--secondary",
                                primary: true,
                                promptTrigger: true,
                                click: (notice, value) => {
                                    notice.close();
                                    notice.fire("pnotify.cancel", { notice, value });
                                    subject.next(false);
                                    subject.complete();
                                    return false;
                                }
                            }
                        ]
                    },
                    Buttons: {
                        closer: false,
                        sticker: false
                    }
                },
                stack: {
                    modal: true
                }
            });
            return subject.asObservable();
        } else {
            return true;
        }
    }
}
